/**
 * Comment or uncomment modules as needed
 */

import 'reflect-metadata';
import 'rxjs/Observable';
import 'zone.js/dist/zone';

import '@angular/common';
import '@angular/compiler';
import '@angular/core';
// import '@angular/forms';
import '@angular/http';
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
// import '@angular/router';


// WEBPACK FOOTER //
// ./assets_dev/ts/app/vendor.ts